export const FETCH_COLLECTIVES_INIT = 'FETCH_COLLECTIVES_INIT';
export const FETCH_COLLECTIVES_SUCCESS = 'FETCH_COLLECTIVES_SUCCESS';
export const FETCH_COLLECTIVES_META_INIT = 'FETCH_COLLECTIVES_META_INIT';
export const FETCH_COLLECTIVES_META_SUCCESS = 'FETCH_COLLECTIVES_META_SUCCESS';
